import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CredentialsService } from 'src/services/core/credentials/credentials.service';

export const AuthGuard = () => {
  const credentialsService = inject(CredentialsService);
  const router = inject(Router);
  // const state = inject(RouterStateSnapshot);

  if (credentialsService.isAuthenticated()) {
    return true;
  }

  // return state && state.url
  //   ? router.navigate(['/auth'], { queryParams: { returnUrl: state.url } })
  //   : router.parseUrl('/auth');

  return router.parseUrl('/auth');
};
